// Copyright (c) 2017-2022 Uber Technologies Inc.
//
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import moment from 'moment';
import getTimeElapsedDisplay from './get-time-elapsed-display';
import getTimeStampDisplay from './get-time-stamp-display';
import getEventDetails from './get-event-details';
import getEventFullDetails from './get-event-full-details';
import getEventSummary from './get-event-summary';

const getHistoryEvents = ({
  clusterName,
  dateFormat,
  events,
  timeFormat,
  timezone,
  workflowHistoryEventHighlightList,
  workflowHistoryEventHighlightListEnabled,
}) => {
  if (!events) {
    return [];
  }

  return events
    .map((event) => {
      const timestamp = moment(event.timestamp);

      return {
        ...event,
        timestamp,
      };
    })
    .map((event, index, eventList) => {
      const timeStampDisplay = getTimeStampDisplay({
        dateFormat,
        event,
        index,
        timeFormat,
        timezone,
      });
      const timeElapsedDisplay = getTimeElapsedDisplay({
        dateFormat,
        event,
        eventList,
        index,
        timeFormat,
        timezone,
      });

      return {
        ...event,
        timeStampDisplay,
        timeElapsedDisplay,
      };
    })
    .map((event) => {
      const details = getEventDetails({
        clusterName,
        event,
        workflowHistoryEventHighlightList,
        workflowHistoryEventHighlightListEnabled,
      });
      const eventSummary = getEventSummary({ clusterName, event });
      const eventFullDetails = getEventFullDetails({
        clusterName,
        event,
        workflowHistoryEventHighlightList,
        workflowHistoryEventHighlightListEnabled,
      });

      return {
        ...event,
        details,
        eventSummary,
        eventFullDetails,
      };
    });
};

export default getHistoryEvents;
